let container = document.body;
let width = container.offsetWidth;
let height = container.offsetHeight;
//let wave = document.getElementById('wave');
let waves = document.querySelectorAll('path.wave');

let waveWidth = container.offsetWidth;  // Wave SVG width (usually container width)
let waveHeight = 30;                    // Position from the top of container
let waveDelta = 50;                     // Wave amplitude
let speed = 0.25;                       // Wave animation speed
let wavePoints = 4;                     // How many point will be used to compute our wave

let points = [];

function calculateWavePoints(factor) {
    let points = [];

    for (let i = 0; i <= wavePoints; i++) {
        let x = i / wavePoints * waveWidth;
        let sinSeed = (factor + (i + i % wavePoints)) * speed * 100;
        let sinHeight = Math.sin(sinSeed / 100) * waveDelta;
        let yPos = Math.sin(sinSeed / 100) * sinHeight + waveHeight;
        points.push({x: x, y: yPos});
    }

    return points;
}

function buildPath(points) {
    let SVGString = 'M ' + points[0].x + ' ' + points[0].y;

    let cp0 = {
        x: (points[1].x - points[0].x) / 2,
        y: (points[1].y - points[0].y) + points[0].y + (points[1].y - points[0].y)
    };

    SVGString += ' C ' + cp0.x + ' ' + cp0.y + ' ' + cp0.x + ' ' + cp0.y + ' ' + points[1].x + ' ' + points[1].y;

    let prevCp = cp0;
    let inverted = -1;

    for (let i = 1; i < points.length - 1; i++) {
        let cpLength = Math.sqrt(prevCp.x * prevCp.x + prevCp.y * prevCp.y);
        let cp1 = {
            x: (points[i].x - prevCp.x) + points[i].x,
            y: (points[i].y - prevCp.y) + points[i].y
        };

        SVGString += ' C ' + cp1.x + ' ' + cp1.y + ' ' + cp1.x + ' ' + cp1.y + ' ' + points[i + 1].x + ' ' + points[i + 1].y;
        prevCp = cp1;
        inverted = -inverted;
    }

    SVGString += ' L ' + width + ' ' + height;
    SVGString += ' L 0 ' + height + ' Z';
    return SVGString;
}

let lastUpdate;
let totalTime = 0;

function tick() {
    let now = window.Date.now();

    if (lastUpdate) {
        let elapsed = (now - lastUpdate) / 1000;
        lastUpdate = now;

        totalTime += elapsed;

        let factor = totalTime * Math.PI;
        waves.forEach((item, index) => {
            item.setAttribute('d', buildPath(calculateWavePoints(factor)));
        });
    } else {
        lastUpdate = now;
    }

    window.requestAnimationFrame(tick);
};

tick();